import React from 'react';
import { useInViewAnimation } from '~/hooks/useInViewAnimation';

const HeroSection = ({
  setLoadingGetStarted,
  triggerSignup,
  setLoadingEnquire,
  toggleEnquire,
}: {
  setLoadingGetStarted: (val: boolean) => void;
  triggerSignup: () => void;
  setLoadingEnquire: (val: boolean) => void;
  toggleEnquire: () => void;
}) => {
  const { ref: heroHeadingRef, inView: heroHeadingInView } = useInViewAnimation(
    { threshold: 0.5 }
  );
  const { ref: buttonsRef, inView: buttonsInView } = useInViewAnimation({
    threshold: 0.5,
  });
  const { ref: descriptionRef, inView: descriptionInView } = useInViewAnimation(
    { threshold: 0.5 }
  );
  return (
    <div className="hero-section-container">
      <h1
        ref={heroHeadingRef}
        className={`hero-heading animate-slide-up ${heroHeadingInView ? 'is-in-view' : ''}`}
      >
        Understand Emotion
        <br />
        Measure Impact
        <br />
        Optimise Decisions
      </h1>
      <div
        ref={buttonsRef}
        className={`buttons-container animate-slide-up ${buttonsInView ? 'is-in-view' : ''}`}
      >
        <button
          onClick={async () => {
            setLoadingGetStarted(true);
            triggerSignup();
            setLoadingGetStarted(false);
          }}
          className="button-base get-started-button"
        >
          Get Started
        </button>
        <button
          onClick={async () => {
            setLoadingEnquire(true);
            toggleEnquire();
            setLoadingEnquire(false);
          }}
          className="button-base enquire-button"
        >
          Enquire
        </button>
      </div>
      <p
        ref={descriptionRef}
        className={`description-text animate-slide-up ${descriptionInView ? 'is-in-view' : ''}`}
      >
        <strong className="bold-text">
          Actionable, objective, business insights
        </strong>{' '}
        about how your customers feel using your product, service or content.
      </p>
    </div>
  );
};

export default HeroSection;
